<div class="flex-grow-1 post-section full-width-mobile">
    <!-- ====== Tabs Navigation ====== -->
    <div class="portal-tabs-card portal-tabs-strip mb-2 d-none d-md-block">
        <div class="tabs-wrapper d-flex justify-content-between align-items-center px-2 py-1">
            <div class="scrollable-tabs w-100">
                <div class="nav nav-tabs flex-nowrap text-xxs portal-icon-tabs w-100 justify-content-between" role="tablist">
                    <button
                        class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                        :class="{ active: activeVoiceTab === 'discussions' }"
                        @click="open_discussion_create_tab"
                        type="button"
                        role="tab"
                        :aria-selected="activeVoiceTab === 'discussions'">
                        <i class="bi bi-chat-left-text"></i>
                        <span>Discussions</span>
                    </button>

                    <button
                        class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                        :class="{ active: activeVoiceTab === 'surveys' || activeVoiceTab === 'questions' || activeVoiceTab === 'responses' }"
                        @click="open_survey_create_tab"
                        type="button"
                        role="tab"
                        :aria-selected="activeVoiceTab === 'surveys' || activeVoiceTab === 'questions' || activeVoiceTab === 'responses'">
                        <i class="bi bi-ui-checks-grid"></i>
                        <span>Surveys</span>
                    </button>

                    <button
                        class="nav-link portal-icon-tab d-inline-flex flex-column justify-content-center align-items-center"
                        :class="{ active: activeVoiceTab === 'polls' || activeVoiceTab === 'pollresponses' }"
                        @click="open_poll_create_tab"
                        type="button"
                        role="tab"
                        :aria-selected="activeVoiceTab === 'polls' || activeVoiceTab === 'pollresponses'">
                        <i class="bi bi-bar-chart-steps"></i>
                        <span>Polls</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div
        v-if="show_mobile_your_voice_create_tabs"
        class="your-voice-create-tabs your-voice-create-tabs--floating d-md-none d-flex justify-content-around align-items-center bg-transparent border-0 p-0"
        role="tablist"
        aria-label="Your Voice create options">
        <button
            type="button"
            class="your-voice-create-tab btn border-0 rounded-circle d-inline-flex flex-column align-items-center justify-content-center shadow fw-semibold text-center p-1"
            :class="{ active: activeVoiceTab === 'discussions' }"
            @click="open_discussion_create_tab"
            role="tab"
            :aria-selected="activeVoiceTab === 'discussions'">
            <span class="your-voice-create-tab-icon d-inline-flex align-items-center justify-content-center bg-transparent rounded-circle">
                <i class="bi bi-chat-left-text"></i>
            </span>
            <span>Discussion</span>
        </button>

        <button
            type="button"
            class="your-voice-create-tab btn border-0 rounded-circle d-inline-flex flex-column align-items-center justify-content-center shadow fw-semibold text-center p-1"
            :class="{ active: activeVoiceTab === 'surveys' || activeVoiceTab === 'questions' || activeVoiceTab === 'responses' }"
            @click="open_survey_create_tab"
            role="tab"
            :aria-selected="activeVoiceTab === 'surveys' || activeVoiceTab === 'questions' || activeVoiceTab === 'responses'">
            <span class="your-voice-create-tab-icon d-inline-flex align-items-center justify-content-center bg-transparent rounded-circle">
                <i class="bi bi-ui-checks-grid"></i>
            </span>
            <span>Survey</span>
        </button>

        <button
            type="button"
            class="your-voice-create-tab btn border-0 rounded-circle d-inline-flex flex-column align-items-center justify-content-center shadow fw-semibold text-center p-1"
            :class="{ active: activeVoiceTab === 'polls' || activeVoiceTab === 'pollresponses' }"
            @click="open_poll_create_tab"
            role="tab"
            :aria-selected="activeVoiceTab === 'polls' || activeVoiceTab === 'pollresponses'">
            <span class="your-voice-create-tab-icon d-inline-flex align-items-center justify-content-center bg-transparent rounded-circle">
                <i class="bi bi-bar-chart-steps"></i>
            </span>
            <span>Polls</span>
        </button>
    </div>

    <!-- Tab Content -->
    <div class="d-flex flex-column">
        <div v-show="activeVoiceTab === 'discussions'" class="p-2">
            <Discussion ref="discussion_component" :active_profile="active_profile" />
        </div>
        <!-- Survey Listing & Form View -->
        <div v-show="activeVoiceTab === 'surveys' || activeVoiceTab === 'questions' || activeVoiceTab === 'responses'" class="p-1 py-3">
            <div class="event-survey-experience card border-1 rounded-5 p-3 bg-light shadow-sm overflow-hidden d-none">
                <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 gap-md-4">
                    <div class="d-flex align-items-start gap-3 flex-grow-1">
                        <div class="d-inline-flex align-items-center justify-content-center rounded bg-gray text-primary fs-4 py-2 px-3 flex-shrink-0 border">
                            <i class="bi bi-ui-checks-grid"></i>
                        </div>
                        <div class="flex-grow-1">
                            <h6 class="mb-2 fw-bold text-dark">Surveys that feel worth answering</h6>
                            <p class="mb-0 text-muted text-xs">
                                Browse active surveys, review answers you've already submitted, or create a fresh one for your community.
                            </p>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-start align-items-lg-end gap-3">
                        <div class="d-none d-md-flex flex-nowrap gap-2 justify-content-lg-end w-100 w-lg-auto">
                            <div class="card board-task-card border-0 rounded-4 bg-white px-3 py-2 flex-fill shadow-sm">
                                <span class="d-block fw-bold text-secondary small">Surveys</span>
                                <strong class="d-block fw-bold text-dark fs-5">{{ surveys.length }}</strong>
                            </div>
                        </div>
                        <button
                            v-if="(soulcity_domain && user_details.user_role === 'admin') || !soulcity_domain"
                            @click="show_survey_creation = true; activeVoiceTab = 'questions'"
                            class="btn btn-primary btn-sm rounded px-3 py-1 shadow-sm text-xxs align-self-lg-end text-nowrap">
                            Create survey
                        </button>
                    </div>
                </div>
            </div>
             <div class="card border-1 rounded bg-white p-3 shadow-sm position-relative mb-2">
                <form @submit.prevent="submitSurvey()" novalidate>
                    <button class="btn btn-sm text-muted position-absolute top-0 end-0 m-2"
                        @click="show_survey_creation = !show_survey_creation" title="Close" type="button">
                        <i class="bi fs-5 fw-bold text-dark" :class="show_survey_creation ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>
                    <div class="mb-4 col-xl-8 px-0 pe-4">
                        <p class="fw-bold text-dark text-xs mb-1">{{ survey_id ? 'Edit survey' : 'Create a new survey' }}</p>
                        <p class="text-muted text-sm text-xs mb-0">Shape the questions, add the right options, and keep the experience simple for the people answering it.</p>
                    </div>
                    <div v-if="show_survey_creation">
                    <!-- Survey Title -->
                    <div class="mb-3">
                        <label for="survey_name" class="form-label text-xxs fw-bold">Survey Name<span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control rounded text-xxs" id="survey_name"
                            placeholder="Enter survey name" v-model="survey_name">
                        <p v-if="errors.survey_name" class="text-danger text-xxs mt-1">{{ errors.survey_name }}</p>
                    </div>

                    <!-- Survey Description -->
                    <div class="mb-3">
                        <label for="survey_description" class="form-label text-xxs fw-bold">Survey Description</label>
                        <QuillEditor theme="snow" v-model="survey_description" ref="quillSurveyEditorRef"
                            class="quill-editor" placeholder="Enter your description here..." toolbar="half" />
                    </div>
                    <div class="mb-3">
                        <label for="survey_end_date" class="form-label text-xxs fw-bold">End Date</label>
                        <input
                            type="datetime-local"
                            class="form-control rounded text-xxs"
                            id="survey_end_date"
                            :min="now_date_time_local"
                            v-model="survey_end_date"
                        >
                        <p v-if="errors.survey_end_date" class="text-danger text-xxs mt-1">
                            {{ errors.survey_end_date }}
                        </p>
                    </div>
                    <div class="mb-3">
                        <button type="button" class="btn btn-primary btn-sm float-end text-xxs rounded-3 shadow-sm"
                            @click="showQuestionForm = !showQuestionForm">
                            <i class="bi bi-plus-lg me-1"></i>
                            {{ showQuestionForm ? 'Hide Question Form' : 'Add Question' }}
                        </button>
                        <div v-if="showQuestionForm">

                            <div class="row mt-2 w-100 ">
                                <!-- Question Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question <span class="text-danger">*</span></label>
                                    <div class="d-flex">
                                        <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                                            v-model="newQuestion.text" placeholder="Enter question text"
                                            list="questionSuggestions" @input="onQuestionInput"
                                            @change="onQuestionSelect" />
                                    </div>
                                    <datalist id="questionSuggestions">
                                        <option v-for="question in filteredQuestions" :key="question.id"
                                            :value="question.question"></option>
                                    </datalist>
                                </div>

                                <!-- Question Number Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question Number <span class="text-danger">*</span></label>
                                    <input type="number" class="form-control text-xxs rounded p-2 bg-white"
                                        placeholder="Eg. 1" v-model="newQuestion.question_number" />
                                </div>

                                <!-- Question Type Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Type <span class="text-danger">*</span></label>
                                    <select v-model="newQuestion.type" class="form-select text-xxs p-2 rounded mb-2">
                                        <option value="" disabled>Select</option>
                                        <option
                                            v-for="type in question_types.filter(t => t.question_type !== 'file' && t.question_type !== 'textarea')"
                                            :key="type.id" :value="type.id">
                                            {{ type.question_type }}
                                        </option>
                                    </select>

                                    <!-- Options Input for Multiple Choice, Checkbox, or Selection -->
                                    <div v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)"
                                        v-for="(option, index) in newQuestion.options" :key="option.id || index"
                                        class="d-flex align-items-center gap-2 mb-2 w-100">
                                        <input type="text" class="form-control text-xxs rounded p-2"
                                            v-model="option.text" placeholder="Enter option text" />
                                        <button class="btn btn-light board-icon-btn align-items-center justify-content-center" type="button"
                                            @click="removeOption(index)">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>

                                    <div
                                        v-if="newQuestion.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === newQuestion.type)?.question_type)"
                                        class="d-flex justify-content-end">
                                        <button
                                            class="btn btn-sm btn-warning text-white mt-3 text-xxs rounded-3 shadow-sm fw-500"
                                            type="button" @click="addOption">
                                            Add Option
                                        </button>
                                    </div>
                                </div>

                                <!-- Is Mandatory Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Is the question mandatory?</label>
                                    <select v-model="newQuestion.is_mandatory" class="form-select text-xxs p-2 rounded mb-2">
                                        <option :value="true">Yes</option>
                                        <option :value="false">No</option>
                                    </select>
                                </div>

                                <!-- Add Question Button -->
                                <div class="col-12 mt-3">
                                    <button type="button" class="btn btn-sm btn-success text-xxs rounded float-end"
                                        @click="editingCreatedQuestionIndex === null ? addQuestionToSurvey() : save_created_question_edit()"
                                        :disabled="!newQuestion.text || !newQuestion.type || !newQuestion.question_number">
                                        {{ editingCreatedQuestionIndex === null ? 'Add Question to Survey' : 'Update Question' }}
                                    </button>
                                    <button
                                        v-if="editingCreatedQuestionIndex !== null"
                                        type="button"
                                        class="btn btn-sm btn-light border text-xxs rounded float-end me-2"
                                        @click="clearCreatedQuestionEdit">
                                        Cancel Edit
                                    </button>
                                </div>
                            </div>
                            <div class="mt-3" v-if="createdQuestions.length > 0">
                                <h6 class="text-xxs fw-semibold">Created Questions</h6>
                                <!-- <ul>
                                <li > -->
                                <div v-for="(question, index) in createdQuestions" :key="index"
                                    class="d-flex justify-content-between align-items-center border rounded p-2 text-xxs mb-2 cursor-pointer"
                                    :class="{ 'border-primary bg-light': editingCreatedQuestionIndex === index }"
                                    role="button"
                                    tabindex="0"
                                    @click="edit_created_question(question, index)"
                                    @keyup.enter="edit_created_question(question, index)">
                                    <div class="min-w-0">
                                        <span class="text-xxs">{{ index + 1 }}. {{ question.text }}</span>
                                    </div>
                                    <div class="d-inline-flex align-items-center gap-2 flex-shrink-0">
                                        <span class="text-muted text-xxs">
                                            {{ question.type ? (question_types.find(t => t.id ===
                                            question.type)?.question_type || 'Unknown') : 'Unknown' }}
                                        </span>
                                        <span v-if="question.is_mandatory"
                                            class="text-muted text-xxs">Required</span>
                                        <button type="button" class="btn btn-sm text-danger"
                                            @click.stop="remove_created_question(index)" title="Remove">
                                            <i class="bi bi-trash text-danger"></i>
                                        </button>
                                    </div>
                                </div>
                                <!-- </li>
                            </ul> -->
                            </div>
                        </div>

                    </div>

                    <div class="d-flex justify-content-end gap-2 mt-3">
                        <button
                            v-if="survey_id || createdQuestions.length > 0"
                            type="submit"
                            class="btn btn-sm btn-primary text-xxs rounded-3 shadow-sm"
                        >
                            {{ survey_id ? 'Update' : 'Create' }} Survey
                        </button>
                        <button
                            v-if="survey_id"
                            type="button"
                            class="btn btn-sm btn-danger text-xxs rounded-3"
                            @click="cancelEdit"
                        >
                            Cancel
                        </button>
                    </div>
                    </div>

                </form>
            </div>

            <!-- My Surveys Section - Only shown if user has surveys -->
             <section v-if="my_surveys.length > 0 || available_surveys.length > 0" class="mb-4">
            <p class="fw-bold small mb-1 ms-2 mt-1">Open Surveys</p>

            <section v-if="my_surveys.length > 0">
                <div v-if="my_surveys.length > 0">
                    <div class="card board-task-card mb-3 border-0 rounded-4 shadow-sm bg-white"
                        v-for="survey in my_surveys" :key="survey.id">
                        <div class="card-body p-3 p-md-4">
                            <Transition name="flip" mode="out-in">
                                <!-- FRONT: title + actions -->
                                <div v-if="flipped_id !== survey.id" :key="'front-' + survey.id">
                                    <div class="position-relative cursor-pointer" @click="handle_creator_survey_card_click(survey.id)">
                                        <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                                            <div class="flex-grow-1">
                                                <h6 class="card-title mb-2 fw-bold text-dark">{{ survey.name }}</h6>
                                                <p v-if="survey.description" class="text-xxs text-muted mb-3" v-html="survey.description"></p>
                                            </div>

                                            <div class="d-grid gap-2 justify-content-md-end">
                                                <div class="d-flex align-items-center gap-2 flex-wrap justify-content-end">
                                                    <div class="dropdown" v-if="!survey.is_answered">
                                                        <button class="btn btn-light btn-sm rounded d-inline-flex align-items-center justify-content-center" type="button"
                                                            @click.stop
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i class="bi bi-three-dots-vertical"></i>
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-end">
                                                            <li>
                                                                <a class="dropdown-item text-xxs"
                                                                    @click.prevent="edit_survey(survey)">
                                                                    <i class="bx bxs-edit fs-6"></i> Edit
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item text-xxs text-danger"
                                                                @click.prevent="deleteSurvey(survey.id)">
                                                                <i class="bx bxs-trash-alt fs-6"></i> Delete</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex align-items-center w-100 gap-3 text-xxs text-muted fw-semibold mt-3">
                                            <span class="d-inline-flex align-items-center gap-1">
                                                <i class="bi bi-ui-checks text-secondary"></i>
                                                {{ survey.survey_questions?.length || 0 }} questions
                                            </span>
                                            <span class="d-inline-flex align-items-center gap-1">
                                                <i class="bi bi-people text-secondary"></i>
                                                {{ get_survey_respondent_count(survey) }} responses
                                            </span>
                                            <button
                                                class="btn btn-light border rounded-circle text-secondary p-0 px-1 shadow-sm d-inline-flex align-items-center justify-content-center flex-shrink-0 ms-auto"
                                                type="button"
                                                
                                                @click.stop="flip_to(survey.id)"
                                            >
                                                <i
                                                    class="bi"
                                                    :class="flipped_id === survey.id ? 'bi-chevron-up' : 'bi-chevron-down'"
                                                ></i>
                                            </button>
                                        </div>
                                        <div class="d-flex align-items-center">
                                        <p class="text-xxs text-muted mt-3 mb-0">
                                            Monitor answers, edit the survey before people respond, or open the response view.
                                        </p>
                                    <p class="text-xxs text-muted ms-auto mt-3 mb-0">Created by you</p>
                                    </div>
                                    </div>
                                </div>

                                <!-- BACK: responses for THIS survey only -->
                                <div v-else :key="'back-' + survey.id">
                                    <div class="d-flex justify-content-between align-items-center gap-2 mb-3 flex-wrap">
                                        <div class="flex-grow-1">
                                            <h6 class="card-title mb-0 fw-bold text-dark">{{ survey.name }}</h6>
                                        </div>
                                    </div>

                                    <div class="border-top pt-3">
                                        <div v-for="(question, index) in survey.survey_questions" :key="question.id"
                                            class="mb-3 p-3 rounded-3 border bg-light">
                                            <div class="d-flex justify-content-between align-items-center gap-2 text-xxs flex-wrap">
                                                <p class="fw-bold mb-0">{{ index + 1 }}. {{ question.question.question
                                                    }}</p>
                                                <a class="btn btn-link text-success text-xxs text-decoration-none p-0"
                                                    @click="toggleQuestionResponses(question.id)">
                                                    Responses ({{ question.answers?.length || 0 }})
                                                    <span v-if="expandedQuestions.get(question.id)">▲</span>
                                                    <span v-else>▼</span>
                                                </a>
                                            </div>

                                            <ul class="list-group list-group-flush mt-2"
                                                v-show="expandedQuestions.get(question.id)">
                                                <li v-for="(response, response_id) in question.answers"
                                                    :key="response_id"
                                                    class="list-group-item py-1 px-2 small fw-light text-xxs">
                                                    <i class="bi bi-dot text-secondary me-1"></i>
                                                    <strong v-if="response.user.is_blocked">Unknown User</strong>
                                                    <strong v-else>{{ response.user?.first_name }} {{
                                                        response.user?.last_name }}</strong>
                                                    <button
                                                        v-if="question.question.question_type.question_type === 'file'"
                                                        class="btn btn-link btn-sm text-success text-decoration-none p-0 ms-1 align-baseline"
                                                        type="button"
                                                        @click="view_survey_answer_file(response)">
                                                        Preview {{ get_survey_answer_file_name(response) }}
                                                    </button>
                                                    <span v-else>
                                                        : {{ response.answer || '—' }}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end align-items-center gap-2 mt-3 pt-2 border-top">
                                        <button
                                            class="btn btn-outline-success btn-sm rounded-3 px-3"
                                            @click.stop="download_survey_results_excel(survey)">
                                            Export Excel
                                        </button>
                                        <button
                                            class="btn btn-outline-dark btn-sm rounded-3 px-3"
                                            @click="unflip">
                                            Back
                                        </button>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                    </div>

                </div>

                <div v-else class="text-muted text-xxs">
                    <div v-if="surveys.length === 0" class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-5 gap-3">
                        <i class="bi bi-clipboard-check fs-1 text-primary"></i>
                        <p class="mb-0 text-xs">
                            No surveys yet.
                        </p>
                    </div>
                </div>


            </section>
            <section v-if="available_surveys.length > 0">
                <div v-for="survey in available_surveys" :key="survey.id">

                    <div class="card board-task-card mb-3 border-0 rounded-4 shadow-sm bg-white">
                        <div class="card-body p-3 p-md-4">
                            <div class="cursor-pointer" @click="handle_user_survey_card_click(survey)">
                                <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                                    <div class="flex-grow-1">
                                        <div class="card-title mb-2 d-flex align-items-center flex-wrap gap-2 text-xxs fw-bold text-dark">
                                            <h6 class="fw-bold">{{ survey.name }}</h6>
                                            <span v-if="survey.is_answered"
                                                class="badge rounded-pill bg-success-subtle text-success-emphasis text-xxs">Answered</span>
                                        </div>
                                        <p
                                            v-if="survey.description"
                                            class="mb-3 text-xxs text-muted"
                                            v-html="survey.description"></p>
                                        <p v-else class="mb-3 text-xxs text-muted">
                                            Share a few quick answers and help shape what happens next.
                                        </p>

                                    </div>

                                    <div class="d-flex flex-column align-items-start align-items-md-end gap-2 text-md-end">
                                        <div class="text-xxs text-muted">
                                            <span v-if="survey.is_answered">You have already shared your response.</span>
                                            <span v-else-if="survey_has_ended(survey)">This survey is no longer accepting responses.</span>
                                            <span v-else>Take a minute to answer this survey.</span>
                                        </div>

                                        <span
                                            v-if="survey.end_date && !survey_has_ended(survey)"
                                            class="task-chip task-chip-priority"
                                        >
                                            {{ survey_ends_in_text(survey) }}
                                        </span>

                                    </div>
                                </div>

                                <div class="d-flex align-items-center w-100 gap-2 text-xxs text-muted fw-semibold mt-3">
                                    <span class="d-inline-flex align-items-center gap-1">
                                        <i class="bi bi-ui-checks text-secondary"></i>
                                        {{ survey.survey_questions?.length || 0 }} questions
                                    </span>
                                    <button
                                        v-if="survey.is_answered || !survey_has_ended(survey)"
                                        class="btn btn-light border rounded-circle text-secondary p-0 px-1 shadow-sm ms-auto d-inline-flex align-items-center justify-content-center flex-shrink-0"
                                        type="button"
                                        
                                        @click.stop="survey.is_answered ? survey.showAnswers = !survey.showAnswers : toggleSurvey(survey.id)"
                                    >
                                        <i
                                            class="bi"
                                            :class="survey.is_answered
                                                ? (survey.showAnswers ? 'bi-chevron-up' : 'bi-chevron-down')
                                                : (selectedSurveyId === survey.id ? 'bi-chevron-up' : 'bi-chevron-down')"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                            <!-- description intentionally hidden -->
                            <!-- <p class="text-xxs d-none" v-html="survey.description"></p> -->

                            <div v-if="survey.is_answered" class="mt-3">
                                <div v-if="survey.showAnswers"
                                    v-for="(question, index) in filteredSurveys.find(s => s.id === survey.id)?.survey_questions"
                                    :key="question.id" class="d-flex flex-column rounded border p-3 mb-3 bg-light">
                                    <label class="text-xs fw-bold mb-1 d-block">
                                        {{ index + 1 }}. {{ question.question.question }}
                                    </label>

                                    <!-- Yes/No -->
                                    <div v-if="question.question.question_type.question_type === 'yes_no'"
                                        class="mb-2">
                                        <div v-for="opt in ['Yes', 'No']" :key="opt"
                                            class="form-check form-check-inline">
                                            <input type="radio" class="form-check-input"
                                                :name="'q' + question.question.id" :value="opt"
                                                :checked="question.answers?.some(a => a.answer === opt)" disabled />
                                            <label class="form-check-label text-xxs">{{ opt }}</label>
                                        </div>
                                    </div>

                                    <!-- Multiple Choice -->
                                    <div v-else-if="question.question.question_type.question_type === 'multiple_choice'"
                                        class="mb-2">
                                        <div v-for="opt in question.question.options" :key="opt.id"
                                            class="form-check form-check-inline">
                                            <input type="radio" class="form-check-input"
                                                :id="'q' + question.question.id + '-' + opt.id"
                                                :name="'q' + question.question.id" :value="opt.option"
                                                :checked="question.answers?.some(a => a.answer === opt.option)"
                                                disabled />
                                            <label class="form-check-label text-xxs"
                                                :for="'q' + question.question.id + '-' + opt.id">
                                                {{ opt.option }}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Selection -->
                                    <select
                                        v-else-if="question.question.question_type.question_type === 'selection'"
                                        class="form-select text-xxs rounded mb-2" disabled>
                                        <option v-for="option in question.question.options" :key="option.id"
                                            :value="option.option"
                                            :selected="question.answers?.some(a => a.answer === option.option)">
                                            {{ option.option }}
                                        </option>
                                    </select>

                                    <!-- Checkbox -->
                                    <div v-else-if="question.question.question_type.question_type === 'checkbox'"
                                        class="mb-2">
                                        <div v-for="option in question.question.options" :key="option.id"
                                            class="form-check">
                                            <input type="checkbox" class="form-check-input text-xxs"
                                                :id="'checkbox_' + option.id" :value="option.option"
                                                :checked="question.answers?.some(a => a.answer === option.option)"
                                                disabled />
                                            <label class="form-check-label text-xxs" :for="'checkbox_' + option.id">
                                                {{ option.option }}
                                            </label>
                                        </div>
                                    </div>

                                    <!-- Text -->
                                    <input v-else-if="question.question.question_type.question_type === 'text'"
                                        type="text" class="form-control text-xxs rounded mb-2"
                                        :value="question.answers?.[0]?.answer || ''" disabled />
                                    <!-- Number -->
                                    <input v-else-if="question.question.question_type.question_type === 'number'"
                                        type="number" class="form-control text-xxs rounded mb-2"
                                        :value="question.answers?.[0]?.answer || ''" disabled />

                                    <!-- Date -->
                                    <input v-else-if="question.question.question_type.question_type === 'date'"
                                        type="date" class="form-control text-xxs rounded mb-2"
                                        :value="question.answers?.[0]?.answer || ''" disabled />

                                    <!-- Link -->
                                    <input v-else-if="question.question.question_type.question_type === 'link'"
                                        type="url" class="form-control text-xxs rounded mb-2"
                                        :value="question.answers?.[0]?.answer || ''" disabled />

                                    <!-- File -->
                                    <div v-else-if="question.question.question_type.question_type === 'file'"
                                        class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 mb-2">
                                        <input
                                            type="text"
                                            class="form-control text-xxs rounded"
                                            :value="get_survey_answer_file_name(getUserAnswer(question))"
                                            disabled />
                                        <button
                                            v-if="get_survey_answer_file_url(getUserAnswer(question))"
                                            class="btn btn-outline-secondary btn-sm rounded-3 text-xxs text-nowrap"
                                            type="button"
                                            @click="view_survey_answer_file(getUserAnswer(question))">
                                            Preview
                                        </button>
                                    </div>
                                </div>

                                <!-- Close answers view -->
                                <div class="d-flex justify-content-end mt-3" v-if="survey.showAnswers">
                                    <button class="btn btn-danger btn-sm rounded-3 px-3 text-white" type="button"
                                        @click.stop="survey.showAnswers = false">
                                        Cancel
                                    </button>
                                </div>

                            </div>

                            <div v-show="selectedSurveyId === survey.id && !survey_has_ended(survey) && !survey_is_answered(survey)" class="mt-3 pt-3 border-top">
                                <div v-for="(question, index) in survey.survey_questions" :key="question.id"
                                    class="p-3 rounded-3 border bg-light mb-3">
                                    <label class="text-xs fw-bold mb-2 d-block">{{ index + 1 }}. {{ question.question.question }}</label>
                                    <hr class="my-3">

                                    <div v-if="question.question.question_type.question_type === 'yes_no'">
                                        <div v-for="opt in ['Yes', 'No']" :key="opt" class="form-check">
                                            <input type="radio" class="form-check-input text-xxs"
                                                :name="'q' + question.question.id" :value="opt"
                                                v-model="answers[question.question.id]">
                                            <label class="form-check-label text-xxs">{{ opt }}</label>
                                        </div>
                                    </div>

                                    <div
                                        v-else-if="question.question.question_type.question_type === 'multiple_choice'">
                                        <div v-for="opt in question.question.options" :key="opt.id"
                                            class="form-check">
                                            <input type="radio" class="form-check-input text-xxs"
                                                :id="'q' + question.question.id + '-' + opt.id"
                                                :name="'q' + question.question.id" :value="opt.option"
                                                v-model="answers[question.question.id]">
                                            <label class="form-check-label text-xxs"
                                                :for="'q' + question.question.id + '-' + opt.id">{{ opt.option
                                                }}</label>
                                        </div>
                                    </div>

                                    <select
                                        v-else-if="question.question.question_type.question_type === 'selection'"
                                        class="form-select text-xxs rounded"
                                        :id="'question_' + question.question.id"
                                        v-model="answers[question.question.id]">
                                        <option value="" disabled>Select an option</option>
                                        <option v-for="option in question.question.options" :key="option.id"
                                            :value="option.option">
                                            {{ option.option }}
                                        </option>
                                    </select>

                                    <div v-else-if="question.question.question_type.question_type === 'checkbox'"
                                        class="form-check">
                                        <div v-for="option in question.question.options" :key="option.id"
                                            class="form-check form-check-sm px-0 py-1">
                                            <input type="checkbox" class="form-check-input text-xxs mt-2"
                                                :id="'checkbox_' + option.id" :value="option.option" @change="toggleCheckboxAnswer(
                                        survey,
                                        question.question.id,
                                        option.option,
                                        $event.target.checked
                                        )" />
                                            <label class="form-check-label text-xxs mt-0"
                                                :for="'checkbox_' + option.id">
                                                {{ option.option }}
                                            </label>
                                        </div>

                                    </div>

                                    <!-- Text Input -->
                                    <textarea v-if="question.question.question_type.question_type === 'text'"
                                        class="form-control text-xxs rounded"
                                        :id="'question_' + question.question.id"
                                        :placeholder="question.question.question"
                                        v-model="answers[question.question.id]" rows="3"></textarea>

                                    <div class="mb-3"
                                        v-else-if="question.question.question_type.question_type === 'number'">
                                        <input type="number" class="form-control text-xxs rounded w-100"
                                            :id="'question_' + question.question.id"
                                            v-model="answers[question.question.id]"
                                            :placeholder="question.question.question"
                                            @input="validateNumber(question.question.id)" />

                                        <p v-if="numberErrors[question.question.id]"
                                            class="text-danger text-xxs mt-1">
                                            {{ numberErrors[question.question.id] }}
                                        </p>
                                    </div>


                                    <input v-else-if="question.question.question_type.question_type === 'date'"
                                        type="date" class="form-control text-xxs rounded w-100 rounded"
                                        :id="'question_' + question.question.id"
                                        v-model="answers[question.question.id]" />

                                    <input v-else-if="question.question.question_type.question_type === 'link'"
                                        type="url" class="form-control text-xxs rounded w-100 rounded"
                                        :id="'question_' + question.question.id"
                                        v-model="answers[question.question.id]" />

                                    <div v-else-if="question.question.question_type.question_type === 'file'">
                                        <input
                                            type="file"
                                            class="form-control text-xxs rounded w-100"
                                            :id="'question_' + question.question.id"
                                            accept=".pdf,.doc,.docx"
                                            @change="handle_survey_file_upload($event, question)"
                                        />
                                        <p
                                            v-if="answers[question.question.id]"
                                            class="text-muted text-xxs mt-2 mb-0">
                                            Selected file: {{ answers[question.question.id] }}
                                        </p>
                                        <p v-if="question.question.id === firstErrorQuestionId" class="text-danger text-xxs mt-1">
                                            {{ errors.find(error => error.id === question.question.id)?.message }}
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end gap-2 mt-3"
                                    v-if="selectedSurveyId === survey.id">
                                    <button class="btn btn-primary btn-sm rounded-3 px-3 shadow-sm text-xxs fw-500"
                                        @click.stop="submitSurveyAnswers(survey)">
                                        Submit
                                    </button>
                                    <button class="btn btn-danger btn-sm rounded-3 px-3 text-xxs fw-500" type="button"
                                        @click.stop="toggleSurvey(survey.id)">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
            </section>
              <section v-else-if="my_surveys.length <= 0 || available_surveys.length <= 0"
                class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-5 gap-3">
                <i class="bi bi-chat-square-heart fs-1 text-primary"></i>
                <p class="mb-0 text-xs">No available survey right now.</p>
            </section>



        </div>

        <div class="tab-content">
            <!-- poll Form Tab -->
            <div v-if="activeVoiceTab === 'polls'" class="p-2">
                <div class="card border-1 rounded bg-white px-3 py-3 p-md-4 position-relative mb-4 shadow-sm">
                    <form @submit.prevent="poll_id ? updatePoll() : submitPollForm()">
                        <button class="btn btn-sm text-muted position-absolute top-0 end-0 m-2" type="button"
                            @click="show_poll_creation = !show_poll_creation" title="Close">
                            <i class="bi fs-5 fw-bold text-dark" :class="show_poll_creation ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>
                        <div class="mb-4 col-xl-8 px-0 pe-4">
                            <p class="fw-bold text-dark text-xs mb-1">{{ poll_id ? 'Edit poll' : 'Create a new poll' }}</p>
                            <p class="text-muted text-sm small mb-0">Keep it short, crisp, and easy to answer in a few seconds.</p>
                        </div>
                        <div v-if="show_poll_creation">
                        <!-- <div class="mb-3"></div> -->
                        <label class="form-label text-xxs fw-500">Poll Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control form-control-lg text-xxs rounded" id="poll_name"
                            placeholder="Poll Name" v-model="poll_name" />
                        <p v-if="errors.poll_name" class="text-danger text-xxs mt-1">
                            {{ errors.poll_name }}
                        </p>
                        <label class="form-label text-xxs fw-500">Enter Question <span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control form-control-lg text-xxs rounded"
                            placeholder="What is your question?" v-model="poll_question" />
                        <p v-if="errors.poll_question" class="text-danger text-xxs mt-1">
                            {{ errors.poll_question }}
                        </p>
                        <label class="form-label text-xxs fw-500">Poll Options <span
                                class="text-danger">*</span></label>
                        <div v-for="(option, index) in options" :key="index" class="poll-option mb-2">
                            <div class="input-group">
                                <input type="text" class="form-control form-control-lg text-xxs rounded"
                                    :placeholder="`Answer ${index + 1}`" v-model="option.value"
                                    @input="on_input(index)" />
                                <p v-if="errors.poll_answer" class="text-danger text-xxs mt-1">
                                    {{ errors.poll_answer }}
                                </p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="submit" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm">
                                {{ poll_id ? 'Update' : 'Create' }} Poll
                            </button>
                            <button v-if="poll_id" type="button" class="btn btn-sm btn-danger text-xxs rounded-3 ms-2"
                                @click="cancelEditPoll">
                                Cancel
                            </button>
                        </div>
                        </div>
                    </form>
                </div>
            <!-- Poll Listing & Form View -->
                <!-- Create Poll Button -->
                <div class="d-none event-survey-experience card border-1 rounded-5 p-3 p-md-4 mb-4 bg-light shadow-sm">
                    <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 gap-md-4">
                        <div class=" d-flex align-items-start gap-3 flex-grow-1">
                          <div class="d-inline-flex align-items-center justify-content-center rounded bg-light text-primary fs-4 py-2 px-3 flex-shrink-0 border">
                            <i class="bi bi-bar-chart-steps"></i>
                          </div>
                          <div class="flex-grow-1">
                            <h6 class="mb-2 fw-bold text-dark">Polls that are easy to scan and answer</h6>
                            <p class="mb-0 text-muted text-xs">
                                Use polls for fast sentiment checks, quick decisions, and lightweight community feedback.
                            </p>
                        </div>
                        </div>
                        <div class="d-flex flex-column align-items-start align-items-lg-end gap-3">
                        <div class="d-none d-md-flex flex-nowrap gap-2 justify-content-lg-end w-100 w-lg-auto">
                            <div class="card board-task-card border-0 rounded-4 bg-white px-3 py-2 flex-fill shadow-sm">
                                <span class="d-block text-uppercase fw-bold text-secondary small"> Polls</span>
                                <strong class="d-block fw-bold text-dark fs-5">{{ polls.length }}</strong>
                            </div>
                        </div>
                        <button
                            v-if="(soulcity_domain && user_details.user_role === 'admin') || !soulcity_domain"
                            @click="show_poll_creation = true; activeVoiceTab = 'polls'"
                            class="btn btn-primary btn-sm rounded px-3 py-1 shadow-sm text-xxs">
                            Create poll
                        </button>
                    </div>
                </div>
                </div>

                <div v-if="polls.length > 0">
                <p class="fw-bold small mb-1 ms-2 mt-1">Open Polls</p>

                    <div class="p-1 py-0">
                        <section v-if="my_polls.length > 0 || polls.length === 0">

                            <!-- CASE 1: User has polls -->
                            <div v-if="my_polls.length > 0">

                                <div v-for="poll in my_polls" :key="poll.id"
                                    class="card board-task-card card-hover mb-4 p-3 p-md-4 d-flex flex-column rounded-4 border-0 bg-white full-width-mobile shadow-sm">

                                    <div class="card-body p-0">
                                        <!-- Header -->
                                        <div class="d-flex justify-content-between align-items-start mb-2">
                                            <div>
                                            <p class="mb-0 fw-500 text-dark small">
                                                   Poll: {{ poll.name }}
                                            </p>
                                            </div>

                                            <div class="dropstart" v-if="!poll.is_answered" @click.stop>
                                                <a href="" class="btn btn-light btn-sm rounded-circle d-inline-flex align-items-center justify-content-center" id="pollDropdownMenu"
                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="bi bi-three-dots-vertical"></i>
                                                </a>
                                                <ul class="dropdown-menu custom-dropdown"
                                                    aria-labelledby="pollDropdownMenu">
                                                    <li>
                                                        <a class="dropdown-item text-xxs" href=""
                                                            @click.prevent="editPoll(poll)">
                                                            <i class="bx bxs-edit fs-6"></i> Edit
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item text-xxs text-danger" href=""
                                                            @click.prevent="deletePoll(poll.id)">
                                                            <i class="bx bxs-trash-alt fs-6"></i> Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <!-- Questions + options -->
                                        <div v-for="question in poll.poll_questions" :key="question.id" class="mb-3 p-3 rounded-3 border bg-light">
                                            <div class="d-flex justify-content-between align-items-start gap-2 mb-3 flex-wrap">
                                                <p class="text-dark text-xxs fw-bold mb-0">
                                                    {{ question.question.question }}
                                                </p>
                                                <span class="task-due-chip rounded-3 bg-white text-secondary border fw-semibold px-3 py-2">
                                                    {{ question.answers?.length || 0 }} votes
                                                </span>
                                            </div>

                                            <div>
                                                <div v-for="option in question.question.options" :key="option.id"
                                                    class="mb-2 p-2 rounded bg-white border">
                                                    <div class="d-flex justify-content-between align-items-center gap-2 mb-1">
                                                        <span class="text-xxs fw-semibold text-dark">{{ option.option }}</span>
                                                        <span class="text-xxs text-muted text-end">
                                                            {{ getVotes(question, option) }}
                                                        </span>
                                                    </div>

                                                    <div class="progress bg-light mb-1 rounded-pill overflow-hidden">
                                                        <div class="progress-bar bg-success rounded-pill" role="progressbar"
                                                            :style="{ width: getPercentage(question, option) + '%' }">
                                                        </div>
                                                    </div>

                                                    <div class="text-end text-xxs text-muted">
                                                        {{ getPercentage(question, option) }}%
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="d-flex align-items-center">
                                    <p class="mb-1 text-xxs text-dark ms-auto">Created by you</p>
                                    </div>
                                </div>

                            </div>
                            <!-- CASE 2: User has no polls but others exist -->
                            <div v-else-if="polls.length === 0" class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-5 gap-3">
                                <i class="bi bi-clipboard-data fs-1 text-primary"></i>
                                <p class="mb-0 text-xs">No polls yet.</p>
                            </div>

                        </section>
                    </div>


                    <!-- ===================== AVAILABLE POLLS SECTION ===================== -->
                    <div class="p-1 py-0">
                        <section>

                            <!-- CASE 1: Available polls exist -->
                            <div v-if="available_polls.length > 0">

                                <div v-for="poll in available_polls" :key="poll.id"
                                    class="card board-task-card card-hover mb-4 p-3 p-md-4 d-flex flex-column rounded-4 border-0 bg-white full-width-mobile shadow-sm">
                                    <div class="card-body p-0">
                                        <div class="d-flex justify-content-between align-items-start mb-3">
                                          <p class="mb-0 fw-500 text-dark small">
                                                   Poll: {{ poll.name }}
                                            </p>
                                            <div class="text-end text-xxs text-muted">
                                                <span v-if="poll.is_answered">You have already voted in this poll.</span>
                                                <span v-else>Cast a quick vote in a few seconds.</span>
                                            </div>
                                        </div>

                                        <div v-for="(question, index) in poll.poll_questions" :key="question.id"
                                            class="mb-3 p-3 rounded-3 bg-light border">
                                            <div class="d-flex justify-content-between align-items-start gap-2 mb-3 flex-wrap">
                                                <p class="text-dark text-xxs fw-bold mb-0">
                                                    {{ question.question.question }}
                                                </p>
                                            </div>

                                            <div>
                                                <label v-for="option in question.question.options" :key="option.id"
                                                    class="d-block p-2 rounded bg-white border mb-2 cursor-pointer">
                                                    <div class="d-flex align-items-center flex-grow-1 gap-2">
                                                        <input type="radio" class="form-check-input fixed-radio text-xxs"
                                                            :value="option.option" :checked="poll.is_answered
                                                            ? getUserAnswer(question)?.answer === option.option                                                                : getAnswer(question.question.id) === option.option"
                                                            :disabled="poll.is_answered" @change="!poll.is_answered && setAnswer(
                                                            question.question.id,
                                                            option.option
                                                        )" />
                                                        <div class="flex-grow-1 min-w-0">
                                                            <div class="d-flex justify-content-between align-items-center mb-1 gap-2">
                                                                <span class="text-xxs fw-semibold text-dark">{{ option.option }}</span>
                                                                <small class="text-muted text-xxs">
                                                                    {{ getVotes(question, option) }}
                                                                </small>
                                                            </div>
                                                            <div class="progress bg-light mb-1 rounded-pill overflow-hidden">
                                                                <div class="progress-bar bg-success rounded-pill" role="progressbar"
                                                                    :style="{ width: getPercentage(question, option) + '%' }">
                                                                </div>
                                                            </div>
                                                            <div class="text-end text-xxs text-muted">
                                                                {{ getPercentage(question, option) }}%
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>

                                        </div>

                                        <div class="d-flex justify-content-end align-items-center pt-3 mt-1 border-top">
                                            <button v-if="!poll.is_answered"
                                                class="btn btn-primary btn-sm rounded-3 px-3 py-1 text-xxs shadow-sm"
                                                @click="submitPollAnswers(poll)">
                                                Submit
                                            </button>

                                            <span v-else class="badge rounded-pill bg-success-subtle text-success-emphasis text-xxs ms-2">
                                                Answered
                                            </span>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <!-- CASE 2: My polls exist but no available polls -->
                            <div v-else-if="my_polls.length > 0"
                                class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-5 gap-3">
                                <i class="bi bi-chat-square-heart fs-1 text-primary"></i>
                                <p class="mb-0 text-xs">No available polls right now.</p>
                            </div>

                        </section>
                    </div>

                </div>


                <!-- ===================== UNIFIED EMPTY STATE ===================== -->
                <div v-else >
                    <div class="p-1 py-0">
                    <div class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-5 gap-3">
                        <i class="bi bi-clipboard-data fs-1 text-primary"></i>
                        <p class="mb-0 text-xs">No polls yet.</p>
                    </div>
                    </div>
                </div>

            </div>

            <!-- Poll Responses Tab -->
            <div v-show="activeVoiceTab === 'pollresponses'" class="mb-5 p-3">

                <div v-for="poll in polls" :key="poll.id" class="card bg-white p-4 rounded-4 shadow-sm mb-3 border-0">
                    <fieldset class="border border-secondary rounded p-2 position-relative mt-4 overflow-visible">
                        <legend
                            class="position-absolute top-0 start-0 translate-middle-y bg-white px-2 ms-3 fs-6 text-muted">
                            {{ poll.name }}</legend>
                        <div class="d-flex justify-content-between align-items-start">
                            <div>
                                <h6 class="card-title">{{ poll.name }}</h6>
                                <small v-if="showResponsesFor !== poll.id">{{ poll.description }}</small>
                            </div>

                            <div class="d-flex align-items-center">
                                <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow-sm"
                                    @click="togglePollResponses(poll.id)">
                                    {{ showResponsesFor === poll.id ? 'Hide Responses' : 'Responses' }}
                                </button>
                            </div>
                        </div>
                    </fieldset>

                    <div v-show="showResponsesFor === poll.id" class="mt-4 border-top pt-4">
                        <div v-for="(question, index) in poll.poll_questions" :key="question.id"
                            class="mb-3 p-3 bg-light rounded-3 border">
                            <p>{{question}}</p>
                            <div class="d-flex justify-content-between align-items-center">
                                <p class="fw-bold mb-0">{{ index + 1 }}. {{ question.question.question }}</p>
                                <a class="btn text-secondary text-xxs fw-bold"
                                    @click="toggleQuestionResponses(question.id)">
                                    Votes ({{ question.answers?.length || 0 }})
                                    <span v-if="expandedQuestions.get(question.id)">▲</span>
                                    <span v-else>▼</span>
                                </a>
                            </div>

                            <ul class="list-group list-group-flush mt-2" v-show="expandedQuestions.get(question.id)">
                                <li v-for="(response, response_id) in question.answers" :key="response_id"
                                    class="list-group-item py-1 px-2 small text-muted">
                                    <i class="bi bi-dot text-secondary me-1"></i>
                                    <strong>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>:
                                    {{ response.answer || '—' }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="mt-5 mb-5">
                </div>
            </div>

        </div>
    </div>
</div>

<teleport to="body">
    <div class="modal fade" id="pollResponsesModal" tabindex="-1" aria-labelledby="pollResponsesLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">

                <!-- Header -->
                <div class="modal-header bg-primary text-white position-relative">
                    <p class="modal-title text-xxs fw-500 mb-0" id="pollResponsesLabel">
                        {{ selectedPoll?.name }} - Poll votes
                    </p>
                    <button type="button"
                        class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                        data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>

                <!-- Body -->
                <div class="modal-body" v-if="selectedPoll" ref="pdf_content">
                    <!-- Poll header summary -->
                    <div class="mb-3 border-bottom pb-2">
                        <p class="mb-1 text-xxs fw-semibold">
                            {{ selectedPoll.name }}
                        </p>
                        <p class="mb-0 text-muted text-xxs">
                            {{ get_poll_answer_count(selectedPoll) }} people voted
                        </p>

                        <div class="ms-auto d-flex align-items-center me-5">
                            <button @click="exportPollToCSV" class="btn btn-sm btn-light py-0 px-2 me-2 text-xxs">
                                Export CSV
                            </button>
                            <button @click="exportPDF" class="btn btn-sm btn-light py-0 px-2 text-xxs">
                                Export PDF
                            </button>
                        </div>
                    </div>

                    <!-- Questions -->
                    <div v-for="question in selectedPoll.poll_questions" :key="question.id" class="mb-4">
                        <!-- Question text -->
                        <p class="fw-bold text-xxs mb-2">
                            {{ question.question.question }}
                        </p>

                        <!-- Options list -->
                        <div v-for="option in question.question.options" :key="option.id" class="border-bottom py-2">
                            <!-- Option header row: option name + vote count -->
                            <div class="d-flex justify-content-between align-items-center cursor-pointer"
                                @click="toggleOption(question.id, option.id)">
                                <span class="fw-semibold text-xxs">
                                    {{ option.option }}
                                </span>
                                <span class="text-xxs fw-semibold">
                                    {{ getVotes(question, option) }}
                                </span>
                            </div>

                            <!-- Voters list (collapsed / expanded) -->
                            <div v-if="isOptionOpen(question.id, option.id)" class="mt-2">
                                <ul class="list-unstyled mb-0">
                                    <!-- Each voter -->
                                    <li v-for="answer in question.answers.filter(a => a.answer.includes(option.option))"
                                        :key="answer.id" class="d-flex align-items-center py-2">
                                        <!-- Avatar circle: pure Bootstrap -->
                                        <div
                                            class="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-2 py-1 px-2 flex-shrink-0">
                                            <span class="text-xxs fw-bold">
                                                <span v-if="answer.user.is_blocked">?</span>
                                                <span v-else>
                                                    {{
                                                    (answer.user.first_name && answer.user.first_name[0].toUpperCase())
                                                    || (answer.user.last_name && answer.user.last_name[0].toUpperCase())
                                                    || 'U'
                                                    }}
                                                </span>
                                            </span>
                                        </div>

                                        <!-- Name + extra info -->
                                        <div class="flex-grow-1">
                                            <div class="text-xxs fw-semibold">
                                                <span v-if="answer.user.is_blocked">
                                                    Unknown User
                                                </span>
                                                <span v-else>
                                                    {{ answer.user.first_name }} {{ answer.user.last_name }}
                                                </span>
                                            </div>
                                        </div>
                                    </li>

                                    <!-- No voters -->
                                    <li v-if="getVotes(question, option) === 0" class="text-muted text-xxs py-1">
                                        No one has voted for this option yet.
                                    </li>
                                </ul>
                            </div>
                        </div> <!-- /option block -->
                    </div> <!-- /question block -->
                </div> <!-- /modal-body -->

            </div>
        </div>
    </div>
</teleport>


